import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'

import 'prismjs'
import 'prismjs/themes/prism.css'
import 'vue-prism-editor/dist/VuePrismEditor.css'
Vue.use(Vuetify, {
})



// WEBPACK FOOTER //
// ./src/plugins/vuetify.js